import { Component, EventEmitter, OnInit, Output, Input, TemplateRef, HostListener } from '@angular/core';
import { DropdownOption } from '@cms/shared-library';
import { TranslateService } from '@ngx-translate/core';
import { NotificationSearchForm } from 'src/app/models/notification-search.model';
import { TrainingProgramApplicationUtils } from 'src/app/utils/training-program-application.util';
import { MatDialog } from '@angular/material/dialog';

@Component({
    selector: 'app-notifications-search',
    templateUrl: './notifications-search.component.html',
    styleUrls: ['./notifications-search.component.scss'],
    standalone: false
})
export class NotificationsSearchComponent implements OnInit {
  @Input() isClassNotification = true;
  @Input() isUserAdminOrDSA : boolean;
  @Output() notificationSearchCriteriaChanged = new EventEmitter<NotificationSearchForm>();
  currentLang: string = 'en';
  minStartDate: Date = new Date(2001, 0, 1);
  notificationSearchForm: NotificationSearchForm = new NotificationSearchForm();
  sortingOptions: DropdownOption[] = [new DropdownOption('Newest to oldest', 'Du plus récent au plus ancien', 'Newest to oldest',), new DropdownOption('Oldest to newest', 'Du plus ancien au plus récent', 'Oldest to newest')];
  notificationCategoriesForAdminOrDSA: DropdownOption[] = [
    new DropdownOption('All', 'Tous', 'All',),
    new DropdownOption(TrainingProgramApplicationUtils.Classroom, TrainingProgramApplicationUtils.ClassroomFr, TrainingProgramApplicationUtils.ClassroomNotification),
    new DropdownOption(TrainingProgramApplicationUtils.MyLearner, TrainingProgramApplicationUtils.MyLearnerFr, TrainingProgramApplicationUtils.MyLearnersNotification),
    new DropdownOption(TrainingProgramApplicationUtils.MyTeam, TrainingProgramApplicationUtils.MyTeamFr, TrainingProgramApplicationUtils.MyTeamNotification),
    new DropdownOption(TrainingProgramApplicationUtils.Ministry, TrainingProgramApplicationUtils.MinistryFr, TrainingProgramApplicationUtils.MinistryNotification),
    new DropdownOption(TrainingProgramApplicationUtils.Manual, TrainingProgramApplicationUtils.ManualFr, TrainingProgramApplicationUtils.ManualNotification),

  ];
  notificationCategoriesForNonAdminOrDSA: DropdownOption[] = [
    new DropdownOption(TrainingProgramApplicationUtils.Classroom, TrainingProgramApplicationUtils.ClassroomFr, TrainingProgramApplicationUtils.ClassroomNotification),
    new DropdownOption(TrainingProgramApplicationUtils.MyLearner, TrainingProgramApplicationUtils.MyLearnerFr, TrainingProgramApplicationUtils.MyLearnersNotification),
    new DropdownOption(TrainingProgramApplicationUtils.TrainingProvider, TrainingProgramApplicationUtils.TrainingProviderFr, TrainingProgramApplicationUtils.ManualNotification),

  ];
  notificationStatuses: DropdownOption[] = [new DropdownOption('All', 'Tous', 'All'),
  new DropdownOption('Unread', 'Non lu', 'Unread')];

  constructor(public translateService: TranslateService, 
    public dialog: MatDialog) {
    this.currentLang = translateService.currentLang
    translateService.onLangChange.subscribe(lang => {
      this.currentLang = lang.lang;
    });
  }

  ngOnInit(): void {
    this.resetSearchCriteriaFields();
  }

  @HostListener('window:resize', ['$event'])
  onResize(event?: any) {
    if(window.innerWidth >= 821){
      this.closeDialog()
    }
  }

  initSearchForm() {
    this.resetSearchCriteriaFields();
    this.searchNotifications();
  }

  searchNotifications() {
    this.notificationSearchCriteriaChanged.emit(this.notificationSearchForm);
  }

  resetSearchCriteriaFields() {
    this.notificationSearchForm = new NotificationSearchForm();
    this.notificationSearchForm.notificationStatus = 'All';
    this.notificationSearchForm.sortingOption = 'Newest to oldest';
  }

  openDialog(templateRef: TemplateRef<any>) {
    this.dialog.open(templateRef, {
      panelClass: 'full-width-dialog'
      , height: '100%'
      , autoFocus: false
    });
  }

  closeDialog() {
    this.dialog.closeAll();
  }

  performSearch() {
    this.closeDialog();
    this.searchNotifications();
  }

  StartDateChange(a: any) {
    this.notificationSearchForm.fromDate = ( a=='' ? null : a );
  }

  EndDateChange(a: any) {
    this.notificationSearchForm.toDate = a=='' ? null : a;
  }

  ValidStartandEndDate() {
    if (this.notificationSearchForm.fromDate === null && this.notificationSearchForm.toDate === null)
      return false;
    else
      return true;
  }

}
